import React, { createContext, useState, useEffect } from 'react';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notificationsSpin, setNotificationsSpin] = useState([]);

  useEffect(() => {
    const storedNotifications = JSON.parse(localStorage.getItem('notifications')) || [];
    setNotificationsSpin(storedNotifications);

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'NEW_NOTIFICATION') {
          const newNotification = event.data.payload;

          // Get the latest notifications from the state to avoid overwriting them
          setNotificationsSpin((prevNotifications) => {
            const updatedNotifications = [...prevNotifications, newNotification];
            localStorage.setItem('notifications', JSON.stringify(updatedNotifications));
            return updatedNotifications;
          });
        }
      });
    }
  }, []);

  return (
    <NotificationContext.Provider value={[notificationsSpin, setNotificationsSpin]}>
      {children}
    </NotificationContext.Provider>
  );
};
